import { Injectable } from '@angular/core';
import {ResolutionsInterface} from './resolutions.interface';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaQueryService {
  private bh: BehaviorSubject< ResolutionsInterface > =
    new BehaviorSubject<ResolutionsInterface>( {
      isMobile: false,
      isFullHD: false,
      isQHD: false,
      isTablet: false,
      isUHD: false
    } );

  setDisplaySize(width: number = window.innerWidth ): void {
    this.bh.next( {
      isMobile: width < 768,
      isFullHD: width >= 1024 && width < 1440,
      isQHD: width >= 1440 && width < 2560,
      isUHD: width >= 2560,
      isTablet: width >= 768 && width <1024
    });
  }
  getDisplayType(): Observable< ResolutionsInterface > { return this.bh.asObservable(); }
}
